import { render, staticRenderFns } from "./editAboutus.vue?vue&type=template&id=d677fe9a&"
import script from "./editAboutus.vue?vue&type=script&lang=js&"
export * from "./editAboutus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports